export const URL =
  process.env.REACT_APP_API_URL || 'https://hmlapi.televida.med.br';
export const WSURL =
  process.env.REACT_APP_WEBSOCKET_URL || 'wss://websocket.televida.med.br';
export const API = '/api/v1';
export const PATH_LOGIN = '/auth/authenticate';
export const PATH_REFRESH_TOKEN = '/auth/refresh_token';

export const appName = 'TELEVIDA';
